import Vue from "vue";
import RouterLinkComponent from "@app/components/LinkElements/RouterLink.vue";
import HtmlLinkComponent from "@app/components/LinkElements/HtmlLink.vue";
import Prefetcher from '@app/router/prefetcher';
export default Vue.extend({
    props: {
        link: {
            type: String,
            required: true
        },
        newWindow: {
            type: Boolean,
            default: false
        },
        activeClass: {
            type: String,
            default: null
        },
        exactActiveClass: {
            type: String,
            default: null
        }
    },
    components: {
        RouterLinkComponent: RouterLinkComponent,
        HtmlLinkComponent: HtmlLinkComponent
    },
    computed: {
        domain: function () {
            return window.location.protocol + "//" + window.location.hostname;
        },
        isExternal: function () {
            return this.$helpers.isExternalLink(this.link);
        },
        href: function () {
            var href = "";
            if (this.link.indexOf(this.domain) !== -1) {
                // Internal absolute
                href = this.link.replace(this.domain, "");
            }
            else {
                href = this.link;
            }
            if (href == "//" || href.length == 0) {
                href = "/";
            }
            return href;
        },
        target: function () {
            return this.isExternal || this.newWindow ? "_blank" : "_self";
        }
    },
    mounted: function () {
        var _this = this;
        if (!this.isExternal) {
            setTimeout(function () {
                if (typeof _this.$refs.link !== 'undefined') {
                    Prefetcher.observe(_this.$refs.link.$el);
                }
            }, 250);
        }
    }
});
